<template>
  <el-dialog v-model="dialogVisible" title="统计图表" width="95%" top="3vh" :close-on-click-modal="false"
    @close="handleClose" destroy-on-close draggable
    @wheel.stop @mousedown.stop @touchstart.stop>
    <template #header>
      <div class="dialog-header">
        <span class="dialog-title">统计图表</span>
        <el-button type="danger" size="default" :loading="exporting" @click="exportPDF" style="margin-left:auto">
          {{ exporting ? '导出中...' : '导出PDF' }}
        </el-button>
        <el-button type="warning" size="default" :loading="exporting" @click="exportPPTX" style="margin-left:8px">
          {{ exporting ? '导出中...' : '导出PPTX' }}
        </el-button>
        <el-button type="success" size="default" :loading="exporting" @click="exportWord" style="margin-left:8px">
          {{ exporting ? '导出中...' : '导出Word' }}
        </el-button>
      </div>
    </template>
    <div v-loading="loading" class="chart-data-wrapper">
      <!-- 左侧导航栏 -->
      <div class="nav-sidebar">
        <div class="nav-title">导航</div>
        <div class="nav-item" :class="{ active: activeNav === 'total' }" @click="scrollTo('total')">整体情况</div>
        <div v-for="(zjData, idx) in sortedZJList" :key="idx"
          class="nav-item" :class="{ active: activeNav === 'zj_' + idx }"
          @click="scrollTo('zj_' + idx)">{{ zjData.ZJ }}</div>
      </div>
      <!-- 右侧内容区 -->
      <div class="chart-data-container" ref="scrollContainer">
        <!-- 整体部分 -->
        <div class="page-section" ref="section_total">
          <div class="page-title">昌平区耕保空间问题图斑整改日报 &nbsp; {{ dateStr }}</div>
          <div class="chart-grid">
            <div class="chart-cell">
              <div class="cell-title">总体情况(按面积)</div>
              <div ref="totalZTQK" class="chart-box"></div>
            </div>
            <div class="chart-cell">
              <div class="cell-title">当日提交整改图斑（{{ drtjTotal.count }}个，{{ drtjTotal.area }}亩）</div>
              <div ref="totalDRTJ" class="chart-box"></div>
            </div>
            <div class="chart-cell">
              <div class="cell-title">累计审核图斑状态明细</div>
              <div ref="totalLJSH" class="chart-box"></div>
            </div>
            <div class="chart-cell">
              <div class="cell-title">镇街累计提交图斑情况</div>
              <div ref="totalLJTJ" class="chart-box"></div>
            </div>
          </div>
          <div class="page-footer">▲请各镇街优先推进春季摸排时无种植痕迹图斑的整改，并注意上传照片质量，照片缺少方位角、局部拍照等影响图斑审核的情况将按不通过处理。</div>
        </div>
        <!-- 镇街部分 -->
        <div v-for="(zjData, idx) in sortedZJList" :key="idx" class="page-section zj-section"
          :ref="el => setRef('section_zj_' + idx, el)">
          <div class="page-title">{{ zjData.ZJ }}耕保空间问题图斑整改日报 &nbsp; {{ dateStr }}</div>
          <div class="chart-grid">
            <div class="chart-cell">
              <div class="cell-title">总体情况(按面积)</div>
              <div :ref="el => setRef('zjZTQK_' + idx, el)" class="chart-box"></div>
            </div>
            <div class="chart-cell">
              <div class="cell-title">当日提交整改图斑（{{ getZJDRTJTotal(zjData.DRTJ).count }}个，{{ getZJDRTJTotal(zjData.DRTJ).area }}亩）</div>
              <div :ref="el => setRef('zjDRTJ_' + idx, el)" class="chart-box"></div>
            </div>
            <div class="chart-cell">
              <div class="cell-title">累计审核图斑状态明细</div>
              <div :ref="el => setRef('zjLJSH_' + idx, el)" class="chart-box"></div>
            </div>
            <div class="chart-cell">
              <div class="cell-title">镇街累计提交图斑情况</div>
              <div :ref="el => setRef('zjLJTJ_' + idx, el)" class="chart-box"></div>
            </div>
          </div>
          <div class="page-footer">▲请各镇街优先推进春季摸排时无种植痕迹图斑的整改，并注意上传照片质量，照片缺少方位角、局部拍照等影响图斑审核的情况将按不通过处理。</div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import * as echarts from 'echarts';
import axios from 'axios';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { Document, Packer, Paragraph, TextRun, Table, TableRow, TableCell, ImageRun, AlignmentType, WidthType, VerticalAlign } from 'docx';
/* global PptxGenJS */

const instance = axios.create();
instance.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// 合并KJWZ：耕地补充空间 归入 原耕保空间
const KJWZ_ORDER = ['永农', '储备区', '原耕保空间'];
const KJWZ_COLORS = ['#5470c6', '#91cc75', '#fac858'];
function normalizeKJWZ(kjwz) {
  if (kjwz === '耕地补充空间') return '原耕保空间';
  return kjwz;
}

export default {
  name: 'ChartData',
  props: {
    visible: { type: Boolean, default: false },
    startDate: { type: String, default: '' },
  },
  data() {
    return {
      chartData: { total: {}, ZJList: [] },
      loading: false,
      charts: [],
      refs: {},
      activeNav: 'total',
      observer: null,
      exporting: false,
    };
  },
  computed: {
    dialogVisible: {
      get() { return this.visible; },
      set(val) { if (!val) this.$emit('close'); }
    },
    dateStr() {
      if (this.startDate) {
        const parts = this.startDate.split(/[/-]/);
        if (parts.length >= 3) return `${parts[0]}年${parseInt(parts[1])}月${parseInt(parts[2])}日`;
      }
      const d = new Date();
      return `${d.getFullYear()}年${d.getMonth()+1}月${d.getDate()}日`;
    },
    drtjTotal() {
      const data = this.chartData.total?.DRTJ || [];
      let count = 0, area = 0;
      data.forEach(d => {
        (d.Data || []).forEach(item => {
          count += Number(item.Count || 0);
          area += Number(item.Area || 0);
        });
      });
      return { count, area: area.toFixed(2) };
    },
    sortedZJList() {
      const zjList = this.chartData.ZJList || [];
      const ljtj = this.chartData.total?.LJTJ || [];
      if (!ljtj.length) return zjList;
      const order = ljtj.map(d => d.ZJ);
      return [...zjList].sort((a, b) => {
        const ai = order.indexOf(a.ZJ);
        const bi = order.indexOf(b.ZJ);
        return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
      });
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.fetchData();
      }
    }
  },
  methods: {
    setRef(key, el) {
      if (el) this.refs[key] = el;
    },
    getZJDRTJTotal(drtjData) {
      if (!drtjData || !drtjData.length) return { count: 0, area: '0' };
      let count = 0, area = 0;
      drtjData.forEach(d => { count += Number(d.Count || 0); area += Number(d.Area || 0); });
      return { count, area: area.toFixed(2) };
    },
    scrollTo(key) {
      const el = this.refs['section_' + key] || this.$refs['section_' + key];
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        this.activeNav = key;
      }
    },
    setupScrollObserver() {
      if (this.observer) this.observer.disconnect();
      const container = this.$refs.scrollContainer;
      if (!container) return;
      this.observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            const id = entry.target.dataset.sectionId;
            if (id) this.activeNav = id;
          }
        }
      }, { root: container, threshold: 0.3 });
      const totalEl = this.$refs.section_total;
      if (totalEl) { totalEl.dataset.sectionId = 'total'; this.observer.observe(totalEl); }
      this.sortedZJList.forEach((_, idx) => {
        const el = this.refs['section_zj_' + idx];
        if (el) { el.dataset.sectionId = 'zj_' + idx; this.observer.observe(el); }
      });
    },
    handleClose() {
      if (this.observer) this.observer.disconnect();
      this.charts.forEach(c => c && c.dispose());
      this.charts = [];
      this.$emit('close');
    },
    async captureSections(label) {
      const sections = [this.$refs.section_total, ...this.sortedZJList.map((_, idx) => this.refs['section_zj_' + idx])].filter(Boolean);
      const total = sections.length;
      const loadingInstance = this.$loading({
        lock: true,
        text: `正在生成${label}... 0%`,
        background: 'rgba(0, 0, 0, 0.7)',
      });
      const FONT_SCALE = 1.6;
      const applyFontScale = (section, scale) => {
        section.querySelectorAll('.page-title').forEach(el => { el.style.fontSize = (22 * scale) + 'px'; });
        section.querySelectorAll('.cell-title').forEach(el => { el.style.fontSize = (14 * scale) + 'px'; });
        section.querySelectorAll('.page-footer').forEach(el => { el.style.fontSize = (13 * scale) + 'px'; });
      };
      const resetFontScale = (section) => {
        section.querySelectorAll('.page-title').forEach(el => { el.style.fontSize = ''; });
        section.querySelectorAll('.cell-title').forEach(el => { el.style.fontSize = ''; });
        section.querySelectorAll('.page-footer').forEach(el => { el.style.fontSize = ''; });
      };
      const chartOriginals = [];
      const applyChartFontScale = (scale) => {
        chartOriginals.length = 0;
        this.charts.forEach(chart => {
          if (!chart || chart.isDisposed()) return;
          const opt = chart.getOption();
          const orig = { legend: [], xAxis: [], yAxis: [], series: [], graphic: [] };
          if (opt.legend) orig.legend = (opt.legend || []).map(l => ({ fontSize: l.textStyle?.fontSize || 12 }));
          ['xAxis', 'yAxis'].forEach(axisKey => {
            const axes = opt[axisKey];
            if (axes) orig[axisKey] = (Array.isArray(axes) ? axes : [axes]).map(a => ({ labelFontSize: a.axisLabel?.fontSize || 10, nameFontSize: a.nameTextStyle?.fontSize || 12 }));
          });
          if (opt.series) orig.series = opt.series.map(s => ({ fontSize: s.label?.fontSize || 10 }));
          if (opt.graphic) orig.graphic = opt.graphic.map(g => {
            if (g.children) return { children: g.children.map(c => ({ fontSize: c.style?.fontSize || 12 })) };
            return {};
          });
          chartOriginals.push({ chart, orig });
          const newOpt = {};
          if (opt.legend) newOpt.legend = (opt.legend || []).map(l => ({ ...l, textStyle: { ...(l.textStyle || {}), fontSize: Math.round((l.textStyle?.fontSize || 12) * scale) } }));
          ['xAxis', 'yAxis'].forEach(axisKey => {
            const axes = opt[axisKey];
            if (axes) newOpt[axisKey] = (Array.isArray(axes) ? axes : [axes]).map(a => ({
              axisLabel: { ...(a.axisLabel || {}), fontSize: Math.round((a.axisLabel?.fontSize || 10) * scale) },
              nameTextStyle: { ...(a.nameTextStyle || {}), fontSize: Math.round((a.nameTextStyle?.fontSize || 12) * scale) },
            }));
          });
          if (opt.series) newOpt.series = opt.series.map(s => ({ label: { ...(s.label || {}), fontSize: Math.round((s.label?.fontSize || 10) * scale * 0.75) } }));
          // 饼图：重新计算正圆半径（基于当前容器尺寸）
          if (opt.series?.some(s => s.type === 'pie')) {
            const el = chart.getDom();
            const w = el.clientWidth, h = el.clientHeight;
            const minDim = Math.min(w, h);
            newOpt.series = newOpt.series.map((s, idx) => {
              const origS = opt.series[idx];
              if (origS.type === 'pie') {
                return { ...s, radius: [Math.round(minDim * 0.15), Math.round(minDim * 0.28)] };
              }
              return s;
            });
          }
          if (opt.graphic) newOpt.graphic = opt.graphic.map(g => {
            if (g.children) return { ...g, children: g.children.map(c => { if (c.style) return { ...c, style: { ...c.style, fontSize: Math.round((c.style.fontSize || 12) * scale) } }; return c; }) };
            return g;
          });
          chart.setOption(newOpt, false, false);
        });
      };
      const resetChartFonts = () => {
        chartOriginals.forEach(({ chart, orig }) => {
          if (!chart || chart.isDisposed()) return;
          const restoreOpt = {};
          if (orig.legend.length) restoreOpt.legend = orig.legend.map(l => ({ textStyle: { fontSize: l.fontSize } }));
          ['xAxis', 'yAxis'].forEach(axisKey => {
            if (orig[axisKey].length) restoreOpt[axisKey] = orig[axisKey].map(a => ({ axisLabel: { fontSize: a.labelFontSize }, nameTextStyle: { fontSize: a.nameFontSize } }));
          });
          if (orig.series.length) restoreOpt.series = orig.series.map(s => ({ label: { fontSize: s.fontSize } }));
          if (orig.graphic.length) restoreOpt.graphic = orig.graphic.map(g => {
            if (g.children) return { children: g.children.map(c => ({ style: { fontSize: c.fontSize } })) };
            return {};
          });
          chart.setOption(restoreOpt, false, false);
          chart.resize();
        });
      };
      try {
        const results = [];
        for (let i = 0; i < total; i++) {
          const pct = Math.round(((i) / total) * 100);
          loadingInstance.setText(`正在生成${label}... (${i + 1}/${total}) ${pct}%`);
          const section = sections[i];
          applyFontScale(section, FONT_SCALE);
          applyChartFontScale(FONT_SCALE);
          await this.$nextTick();
          // 强制所有图表重新计算尺寸（确保饼图为正圆）
          this.charts.forEach(c => c && !c.isDisposed() && c.resize());
          await new Promise(r => setTimeout(r, 200));
          const canvas = await html2canvas(section, { scale: 8, useCORS: true, logging: false, backgroundColor: '#ffffff' });
          const imgData = canvas.toDataURL('image/png');
          resetFontScale(section);
          resetChartFonts();
          results.push({ imgData, width: canvas.width, height: canvas.height });
        }
        return { results, loadingInstance };
      } catch (e) {
        resetChartFonts();
        loadingInstance.close();
        throw e;
      }
    },
    async exportPDF() {
      this.exporting = true;
      try {
        const { results, loadingInstance } = await this.captureSections('PDF');
        const pdf = new jsPDF('l', 'mm', 'a4');
        const pageW = 297, pageH = 210;
        results.forEach((r, i) => {
          const imgW = pageW;
          const imgH = (r.height * imgW) / r.width;
          const finalH = Math.min(imgH, pageH);
          const offsetY = (pageH - finalH) / 2;
          if (i > 0) pdf.addPage();
          pdf.addImage(r.imgData, 'PNG', 0, offsetY, imgW, finalH, '', 'FAST');
        });
        loadingInstance.setText('正在保存文件...');
        const now = new Date();
        const ds = `${now.getFullYear()}${String(now.getMonth()+1).padStart(2,'0')}${String(now.getDate()).padStart(2,'0')}`;
        pdf.save(`耕保空间问题图斑整改日报_${ds}.pdf`);
        loadingInstance.close();
      } catch (e) {
        console.error('导出PDF失败:', e);
      } finally {
        this.exporting = false;
      }
    },
    async exportPPTX() {
      this.exporting = true;
      const loadingInstance = this.$loading({
        lock: true,
        text: '正在生成PPTX（原生图表）...',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      try {
        const sections = [this.$refs.section_total, ...this.sortedZJList.map((_, idx) => this.refs['section_zj_' + idx])].filter(Boolean);
        const pptx = new PptxGenJS();
        pptx.layout = 'LAYOUT_WIDE';
        // 图表位置布局（2x2网格）
        const positions = [
          { x: 0.2, y: 0.8, w: 6.2, h: 3.1 },
          { x: 6.6, y: 0.8, w: 6.2, h: 3.1 },
          { x: 0.2, y: 4.0, w: 6.2, h: 3.1 },
          { x: 6.6, y: 4.0, w: 6.2, h: 3.1 },
        ];
        // 与页面一致的配色（去掉 # 号）
        const PIE_COLOR_MAP = {
          '已通过': '91cc75',
          '审核中': 'fac858',
          '未提交': '5470c6',
          '未通过': 'ee6666',
        };
        const KJWZ_COLORS = ['5470c6', '91cc75', 'fac858']; // 永农/储备区/原耕保空间
        const LJSH_COLORS = ['91cc75', 'fac858', 'ee6666']; // 已通过/审核中/未通过
        const LJTJ_COLORS = ['5470c6', 'fac858']; // 总任务量/已提交任务量
        const FONT = 'SimHei';

        // 获取当前日期
        const now = new Date();
        const dateStr = `${now.getFullYear()}年${now.getMonth()+1}月${now.getDate()}日`;

        sections.forEach((section, i) => {
          if (i > 0) loadingInstance.setText(`正在生成PPTX... (${i + 1}/${sections.length})`);
          const slide = pptx.addSlide();

          // 标题（左对齐，去掉重复的日期）+ 日期（右对齐）+ 分隔线
          const rawTitle = section.querySelector('.page-title')?.textContent?.trim() || '';
          const title = rawTitle.replace(/\s*\d{4}年\d{1,2}月\d{1,2}日\s*$/, '');
          slide.addText(title, { x: 0.3, y: 0.1, w: 8, h: 0.5, fontSize: 20, bold: true, align: 'left', fontFace: FONT });
          // 垂直分隔线
          slide.addShape(pptx.shapes.RECTANGLE, { x: 8.5, y: 0.15, w: 0.02, h: 0.4, fill: { color: '999999' } });
          // 日期
          slide.addText(dateStr, { x: 8.7, y: 0.1, w: 4.3, h: 0.5, fontSize: 16, bold: true, align: 'right', fontFace: FONT });

          const cellTitles = Array.from(section.querySelectorAll('.cell-title')).map(el => el.textContent?.trim() || '');

          for (let c = 0; c < 4; c++) {
            const chartIdx = i * 4 + c;
            const chart = this.charts[chartIdx];
            const pos = positions[c];
            // 子标题（始终显示）
            slide.addText(cellTitles[c] || '', { x: pos.x, y: pos.y - 0.05, w: pos.w, h: 0.35, fontSize: 14, bold: true, align: 'center', fontFace: FONT });

            if (!chart || chart.isDisposed()) {
              slide.addText('（无数据）', { x: pos.x, y: pos.y + 0.35, w: pos.w, h: pos.h - 0.35, fontSize: 14, align: 'center', valign: 'middle', color: '999999', fontFace: FONT });
              continue;
            }

            const opt = chart.getOption();
            const series = opt.series || [];
            const xAxis = opt.xAxis?.[0] || opt.xAxis;
            const yAxis = opt.yAxis?.[0] || opt.yAxis;

            let chartData = [];
            let isEmpty = false;
            let pieInfo = null; // 饼图中心文字信息

            if (c === 0) {
              // 饼图：数据在 series[0].data 中
              const pieSeries = series[0];
              const pieItems = pieSeries?.data || [];
              if (pieItems.length === 0) {
                isEmpty = true;
              } else {
                // 计算总计（用于中心文字）
                let totalCount = 0, totalArea = 0;
                pieItems.forEach(d => { totalCount += (d.count || 0); totalArea += (d.value || 0); });
                pieInfo = { count: totalCount, area: totalArea.toFixed(2), items: pieItems };
                // 预格式化标签：类型XX个 / XX亩、占比XX%
                const formattedLabels = pieItems.map(d => {
                  const pct = totalArea > 0 ? ((d.value / totalArea) * 100).toFixed(1) : '0';
                  return `${d.name}${d.count || 0}个 / ${(d.value || 0).toFixed(2)}亩、占比${pct}%`;
                });
                chartData = [{
                  name: pieSeries.name || '审核状态',
                  labels: formattedLabels,
                  values: pieItems.map(d => d.value || 0),
                }];
              }
            } else {
              // 柱状图/折线图：labels 来自 axis.data
              const labels = (xAxis?.type === 'category' ? xAxis.data : yAxis?.data) || [];
              if (labels.length === 0 || series.length === 0) {
                isEmpty = true;
              } else {
                chartData = series.map((s, si) => ({
                  name: s.name || `系列${si + 1}`,
                  labels: labels.map(String),
                  values: (s.data || []).map(v => typeof v === 'object' ? (v?.value || 0) : (Number(v) || 0)),
                }));
              }
            }

            if (isEmpty) {
              slide.addText('（无数据）', { x: pos.x, y: pos.y + 0.35, w: pos.w, h: pos.h - 0.35, fontSize: 14, align: 'center', valign: 'middle', color: '999999', fontFace: FONT });
              continue;
            }

            // 通用图表配置
            const isOverall = (i === 0); // 整体图的标注文字小一号
            const chartOpts = {
              x: pos.x, y: pos.y + 0.35, w: pos.w, h: pos.h - 0.35,
              showTitle: false,
              showLegend: true,
              legendPos: 't',
              legendFontSize: 9,
              legendFontFace: FONT,
              catAxisLabelFontSize: 9,
              valAxisLabelFontSize: 9,
              catAxisLabelFontFace: FONT,
              valAxisLabelFontFace: FONT,
              dataLabelFontSize: isOverall ? 7 : 9,
              dataLabelFontFace: FONT,
              showValue: true,
            };

            if (c === 0) {
              // 环形图：自定义图例 + 右侧详情列表
              const detailBoxW = 3.0; // 详情框宽度
              const detailBoxX = pos.x + pos.w - detailBoxW;
              // 按类型名匹配颜色，保证各镇街配色一致
              const pieItemColors = pieInfo.items.map(d => PIE_COLOR_MAP[d.name] || '999999');
              chartOpts.chartColors = pieItemColors;
              chartOpts.showLabel = true;   // 图表上只显示类型名
              chartOpts.showValue = false;
              chartOpts.showPercent = false;
              chartOpts.showLegend = false; // 自定义图例
              // 图表缩小，右侧放详情列表
              chartOpts.x = pos.x;
              chartOpts.w = pos.w - detailBoxW - 0.2;
              chartOpts.y = pos.y + 0.4;
              chartOpts.h = pos.h - 0.5;
              // 标签为短名称
              chartData[0].labels = pieInfo.items.map(d => d.name);
              slide.addChart(pptx.charts.DOUGHNUT, chartData, chartOpts);

              // 自定义图例（在图表顶部内侧，与右上图表图例同高）
              if (pieInfo && pieInfo.items) {
                const legendTexts = [];
                pieInfo.items.forEach((d) => {
                  const c = PIE_COLOR_MAP[d.name] || '999999';
                  legendTexts.push({ text: ' ■ ', options: { fontSize: 9, color: c, fontFace: FONT } });
                  legendTexts.push({ text: `${d.name}  `, options: { fontSize: 9, color: '333333', fontFace: FONT } });
                });
                slide.addText(legendTexts, { x: pos.x + 0.5, y: pos.y + 0.38, w: pos.w - 1.0, h: 0.3, align: 'center', fontFace: FONT });
              }

              // 右侧详情列表（无框，每行不换行，大行间距）
              if (pieInfo && pieInfo.items) {
                const totalVal = pieInfo.items.reduce((s, d) => s + (d.value || 0), 0);
                const detailTexts = [];
                pieInfo.items.forEach((d) => {
                  const c = PIE_COLOR_MAP[d.name] || '999999';
                  const pct = totalVal > 0 ? ((d.value / totalVal) * 100).toFixed(1) : '0';
                  detailTexts.push({
                    text: '■ ',
                    options: { color: c, fontSize: 9, fontFace: FONT },
                  });
                  detailTexts.push({
                    text: `${d.name}，${d.count || 0}个，${(d.value || 0).toFixed(2)}亩，占比${pct}%\n`,
                    options: { color: '333333', fontSize: 9, fontFace: FONT },
                  });
                });
                // 详情文字
                slide.addText(detailTexts, {
                  x: detailBoxX, y: pos.y + 0.45, w: detailBoxW, h: pos.h - 0.7,
                  align: 'left', valign: 'middle', fontFace: FONT,
                  lineSpacing: 28,
                });
              }

              // 中心文字（向上微调）
              if (pieInfo) {
                const cx = chartOpts.x + chartOpts.w / 2;
                const cy = chartOpts.y + chartOpts.h / 2 + 0.05;
                slide.addText([
                  { text: `${pieInfo.count}个\n`, options: { fontSize: 14, bold: true, color: '333333', fontFace: FONT } },
                  { text: `${pieInfo.area}亩`, options: { fontSize: 12, color: '333333', fontFace: FONT } },
                ], { x: cx - 1.0, y: cy - 0.3, w: 2.0, h: 0.6, align: 'center', valign: 'middle' });
              }
            } else if (c === 1) {
              // 水平堆叠柱状图 (DRTJ)：2位小数，轴标题，标注放内侧顶端避免重叠
              chartOpts.chartColors = KJWZ_COLORS;
              chartOpts.barDir = 'bar';
              chartOpts.barGrouping = 'stacked';
              chartOpts.valGridLine = { color: 'FFFFFF', size: 0 }; // 隐藏网格线
              chartOpts.valAxisTitle = '面积(亩)';
              chartOpts.valAxisTitleFontSize = 9;
              chartOpts.valAxisTitleFontFace = FONT;
              chartOpts.dataLabelFormatCode = '0.00';
              chartOpts.showValue = true;
              chartOpts.dataLabelFontSize = 7;
              slide.addChart(pptx.charts.BAR, chartData, chartOpts);
            } else if (c === 2) {
              // 纵向分组柱状图 (LJSH)：标注2位小数
              chartOpts.chartColors = LJSH_COLORS;
              chartOpts.barDir = 'col';
              chartOpts.barGrouping = 'clustered';
              chartOpts.valGridLine = { color: 'FFFFFF', size: 0 }; // 隐藏网格线
              chartOpts.dataLabelFormatCode = '0.00';
              slide.addChart(pptx.charts.BAR, chartData, chartOpts);
            } else if (c === 3) {
              // 柱状+折线组合图 (LJTJ)
              if (chartData.length > 1) {
                // 第一张：蓝色直方图+红色折线（折线不标注，X轴旋转）
                // 其余：蓝色直方图+橙色折线（折线不标注，X轴水平）
                const isFirst = (i === 0);
                const lineColor = isFirst ? 'ee6666' : 'fac858';
                const barLabelSize = isFirst ? 6 : (isOverall ? 7 : 9);
                const multiTypeData = [
                  { type: pptx.charts.BAR, data: [{ ...chartData[0], color: '5470c6', showValue: true }] },
                  { type: pptx.charts.LINE, data: [{ ...chartData[1], color: lineColor, showValue: false }] },
                ];
                chartOpts.chartColors = ['5470c6'];
                chartOpts.barDir = 'col';
                chartOpts.barGrouping = 'clustered';
                chartOpts.valGridLine = { color: 'FFFFFF', size: 0 }; // 隐藏网格线
                chartOpts.dataLabelFormatCode = '0.00';
                chartOpts.dataLabelFontSize = barLabelSize;
                chartOpts.lineDataSymbol = 'circle';
                chartOpts.lineDataSymbolSize = 6;
                chartOpts.lineSize = 2;
                chartOpts.catAxisLabelRotate = isFirst ? 45 : 0;
                slide.addChart(multiTypeData, chartOpts);
              } else {
                chartOpts.chartColors = [LJTJ_COLORS[0]];
                chartOpts.barDir = 'col';
                chartOpts.barGrouping = 'clustered';
                chartOpts.valGridLine = { color: 'FFFFFF', size: 0 }; // 隐藏网格线
                chartOpts.dataLabelFormatCode = '0.00';
                slide.addChart(pptx.charts.BAR, chartData, chartOpts);
              }
            }
          }

          // 页脚：红色三角图标 + 红色文字（无边框）
          let footer = section.querySelector('.page-footer')?.textContent?.trim() || '';
          if (footer) {
            // 去掉已有的三角符号，统一用单个 ▲
            footer = footer.replace(/^▲+\s*/, '');
            // 红色三角 + 文字
            slide.addText([
              { text: '▲ ', options: { color: 'FF0000', fontSize: 12, bold: true, fontFace: FONT } },
              { text: footer, options: { color: 'FF0000', fontSize: 11, bold: false, fontFace: FONT } },
            ], { x: 0.5, y: 7.05, w: 12.1, h: 0.4, valign: 'middle' });
          }
        });

        loadingInstance.setText('正在保存文件...');
        const ds = `${now.getFullYear()}${String(now.getMonth()+1).padStart(2,'0')}${String(now.getDate()).padStart(2,'0')}`;
        const blob = await pptx.write({ outputType: 'blob' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `耕保空间问题图斑整改日报_${ds}.pptx`;
        a.click();
        URL.revokeObjectURL(url);
        loadingInstance.close();
      } catch (e) {
        console.error('导出PPTX失败:', e);
        loadingInstance.close();
      } finally {
        this.exporting = false;
      }
    },
    async exportWord() {
      this.exporting = true;
      const loadingInstance = this.$loading({
        lock: true,
        text: '正在生成Word...',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      try {
        const sections = [this.$refs.section_total, ...this.sortedZJList.map((_, idx) => this.refs['section_zj_' + idx])].filter(Boolean);
        const children = [];
        const MAX_IMG_W = 430;

        sections.forEach((section, i) => {
          if (i > 0) children.push(new Paragraph({ pageBreakBefore: true }));
          // 页面标题
          const title = section.querySelector('.page-title')?.textContent?.trim() || '';
          children.push(new Paragraph({
            alignment: AlignmentType.CENTER,
            spacing: { after: 120 },
            children: [new TextRun({ text: title, bold: true, size: 36, font: 'Microsoft YaHei' })],
          }));
          // 获取4个图表单元格标题
          const cellTitles = Array.from(section.querySelectorAll('.cell-title')).map(el => el.textContent?.trim() || '');
          // 获取4个图表图片及真实尺寸（保持宽高比）
          const chartImgs = [];
          for (let c = 0; c < 4; c++) {
            const chartIdx = i * 4 + c;
            const chart = this.charts[chartIdx];
            if (chart && !chart.isDisposed()) {
              const url = chart.getDataURL({ type: 'png', pixelRatio: 2 });
              const dom = chart.getDom();
              const ratio = dom.clientHeight / dom.clientWidth;
              const w = MAX_IMG_W;
              const h = Math.round(w * ratio);
              chartImgs.push({ data: url.split(',')[1], w, h });
            } else {
              chartImgs.push(null);
            }
          }
          // 构建 2x2 表格
          const makeCell = (img, title) => {
            const paras = [];
            if (title) {
              paras.push(new Paragraph({
                alignment: AlignmentType.CENTER,
                spacing: { after: 60 },
                children: [new TextRun({ text: title, size: 20, font: 'Microsoft YaHei' })],
              }));
            }
            if (img) {
              paras.push(new Paragraph({
                alignment: AlignmentType.CENTER,
                children: [new ImageRun({ data: img.data, transformation: { width: img.w, height: img.h }, type: 'png' })],
              }));
            } else {
              paras.push(new Paragraph({
                alignment: AlignmentType.CENTER,
                children: [new TextRun({ text: '(无数据)', size: 20, color: '999999', font: 'Microsoft YaHei' })],
              }));
            }
            return new TableCell({
              width: { size: 50, type: WidthType.PERCENTAGE },
              verticalAlign: VerticalAlign.CENTER,
              children: paras,
            });
          };
          const table = new Table({
            rows: [
              new TableRow({ children: [makeCell(chartImgs[0], cellTitles[0]), makeCell(chartImgs[1], cellTitles[1])] }),
              new TableRow({ children: [makeCell(chartImgs[2], cellTitles[2]), makeCell(chartImgs[3], cellTitles[3])] }),
            ],
            width: { size: 100, type: WidthType.PERCENTAGE },
          });
          children.push(table);
          // 页脚（红色、大字号）
          const footer = section.querySelector('.page-footer')?.textContent?.trim() || '';
          if (footer) {
            children.push(new Paragraph({
              spacing: { before: 160 },
              children: [new TextRun({ text: footer, size: 28, color: 'FF0000', bold: true, font: 'Microsoft YaHei' })],
            }));
          }
        });

        loadingInstance.setText('正在生成文档...');
        const doc = new Document({
          sections: [{
            properties: {
              page: {
                size: { orientation: 'landscape' },
                margin: { top: 720, bottom: 720, left: 720, right: 720 },
              },
            },
            children,
          }],
        });

        loadingInstance.setText('正在保存文件...');
        const blob = await Packer.toBlob(doc);
        const now = new Date();
        const ds = `${now.getFullYear()}${String(now.getMonth()+1).padStart(2,'0')}${String(now.getDate()).padStart(2,'0')}`;
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `耕保空间问题图斑整改日报_${ds}.docx`;
        a.click();
        URL.revokeObjectURL(url);
        loadingInstance.close();
      } catch (e) {
        console.error('导出Word失败:', e);
        loadingInstance.close();
      } finally {
        this.exporting = false;
      }
    },
    async fetchData() {
      this.loading = true;
      try {
        const serverAddress = process.env.TX_SERVER_ADDRESS_BACK;
        const params = this.startDate ? { date: this.startDate } : {};
        const res = await instance.get(serverAddress + '/api/getChartData', { params });
        this.chartData = res.data;
        await this.$nextTick();
        this.renderAllCharts();
        this.setupScrollObserver();
      } catch (e) {
        console.error('获取图表数据失败:', e);
      } finally {
        this.loading = false;
      }
    },
    renderAllCharts() {
      this.charts.forEach(c => c && c.dispose());
      this.charts = [];
      const t = this.chartData.total || {};
      // 整体图表
      this.renderPieChart(this.$refs.totalZTQK, t.ZTQK);
      this.renderDRTJChart(this.$refs.totalDRTJ, t.DRTJ);
      this.renderLJSHChart(this.$refs.totalLJSH, t.LJSH);
      this.renderLJTJChart(this.$refs.totalLJTJ, t.LJTJ);
      // 镇街图表
      this.sortedZJList.forEach((zj, idx) => {
        this.renderPieChart(this.refs['zjZTQK_' + idx], zj.ZTQK);
        this.renderZJDRTJChart(this.refs['zjDRTJ_' + idx], zj.DRTJ, zj.ZJ);
        this.renderLJSHChart(this.refs['zjLJSH_' + idx], zj.LJSH);
        this.renderZJLJTJChart(this.refs['zjLJTJ_' + idx], zj.LJTJ);
      });
    },
    initChart(el) {
      if (!el) return null;
      const chart = echarts.init(el, null, { devicePixelRatio: 1 });
      this.charts.push(chart);
      return chart;
    },
    // 左上：饼状图 - 保留审核中/已通过/未通过，其余合并为未提交
    renderPieChart(el, data) {
      const chart = this.initChart(el);
      if (!chart || !data) return;
      const shztMap = {};
      const shztCountMap = {};
      let totalCount = 0, totalArea = 0;
      data.forEach(d => {
        const a = Number(d.Area || 0);
        const c = Number(d.Count || 0);
        totalArea += a;
        totalCount += c;
        let key = d.SHZT;
        if (key !== '审核中' && key !== '已通过' && key !== '未通过') key = '未提交';
        if (!shztMap[key]) { shztMap[key] = 0; shztCountMap[key] = 0; }
        shztMap[key] += a;
        shztCountMap[key] += c;
      });
      const order = ['已通过', '审核中', '未通过', '未提交'];
      const pieColors = ['#91cc75', '#fac858', '#ee6666', '#5470c6'];
      const pieData = order.filter(k => shztMap[k]).map((k) => ({
        name: k, value: Number(shztMap[k].toFixed(2)),
        count: shztCountMap[k], area: Number(shztMap[k].toFixed(2)),
        itemStyle: { color: pieColors[order.indexOf(k)] }
      }));
      // 根据容器实际尺寸计算正圆半径
      const w = el.clientWidth, h = el.clientHeight;
      const minDim = Math.min(w, h);
      const innerR = Math.round(minDim * 0.15);
      const outerR = Math.round(minDim * 0.28);
      chart.setOption({
        tooltip: { trigger: 'item', formatter: (p) => `${p.name} ${p.data.count}个, ${p.data.area}亩, 占比${p.percent}%` },
        legend: { top: 5, left: 'center', type: 'scroll' },
        graphic: [{
          type: 'group', left: 'center', top: 'middle',
          children: [
            { type: 'text', style: { text: `${totalCount}个`, fontSize: 14, fontWeight: 'bold', textAlign: 'center', fill: '#333' }, left: 'center', top: -10 },
            { type: 'text', style: { text: `${totalArea.toFixed(2)}亩`, fontSize: 13, textAlign: 'center', fill: '#333' }, left: 'center', top: 12 }
          ]
        }],
        series: [{
          type: 'pie', radius: [innerR, outerR], center: ['50%', '55%'],
          label: { formatter: (p) => `${p.name}\n${p.data.count}个, ${p.data.area}亩\n占比${p.percent}%`, fontSize: 11 },
          data: pieData,
          emphasis: { itemStyle: { shadowBlur: 10, shadowColor: 'rgba(0,0,0,0.3)' } }
        }]
      });
    },
    // 右上：水平柱状图 - DRTJ (Y轴为ZJ, X轴为面积, KJWZ为系列, 合并耕地补充空间)
    renderDRTJChart(el, data) {
      const chart = this.initChart(el);
      if (!chart || !data) return;
      const categories = data.map(d => d.ZJ);
      chart.setOption({
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
        legend: { top: 5, left: 'center', data: KJWZ_ORDER },
        grid: { left: 80, right: 30, top: 45, bottom: 45, containLabel: true },
        yAxis: { type: 'category', data: categories, axisLabel: { fontSize: 10 } },
        xAxis: { type: 'value', name: '面积(亩)', nameLocation: 'center', nameGap: 28 },
        series: KJWZ_ORDER.map((k, i) => ({
          name: k, type: 'bar', stack: 'total',
          label: { show: true, position: 'inside', formatter: (p) => p.value > 0 ? p.value : '', fontSize: 9 },
          data: data.map(d => {
            let val = 0;
            d.Data.forEach(item => { if (normalizeKJWZ(item.KJWZ) === k) val += Number(item.Area || 0); });
            return Number(val.toFixed(2));
          }),
          itemStyle: { color: KJWZ_COLORS[i] }
        }))
      });
    },
    // 左下：柱状图 - LJSH (KJWZ为序列, SHZT为系列, 合并耕地补充空间)
    renderLJSHChart(el, data) {
      const chart = this.initChart(el);
      if (!chart || !data) return;
      const merged = {};
      (data || []).forEach(d => {
        const key = normalizeKJWZ(d.KJWZ);
        if (!merged[key]) merged[key] = { KJWZ: key, Data: [] };
        (d.Data || []).forEach(item => {
          const existing = merged[key].Data.find(x => x.SHZT === item.SHZT);
          if (existing) existing.Area = Number(existing.Area || 0) + Number(item.Area || 0);
          else merged[key].Data.push({ ...item, Area: Number(item.Area || 0) });
        });
      });
      const mergedArr = KJWZ_ORDER.filter(k => merged[k]).map(k => merged[k]);
      const categories = mergedArr.map(d => d.KJWZ);
      const shztTypes = ['已通过', '审核中', '未通过'];
      const colors = ['#91cc75', '#fac858', '#ee6666'];
      chart.setOption({
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
        legend: { top: 5, left: 'center', data: shztTypes },
        grid: { left: 60, right: 30, top: 45, bottom: 45, containLabel: true },
        xAxis: { type: 'category', data: categories, axisLabel: { fontSize: 10 } },
        yAxis: { type: 'value', name: '面积(亩)' },
        series: shztTypes.map((s, i) => ({
          name: s, type: 'bar',
          label: { show: true, position: 'top', formatter: (p) => p.value > 0 ? p.value : '', fontSize: 9 },
          data: mergedArr.map(d => {
            const item = d.Data.find(x => x.SHZT === s);
            return item ? Number((item.Area || 0).toFixed(2)) : 0;
          }),
          itemStyle: { color: colors[i] }
        }))
      });
    },
    // 右下：柱状图+折线图 - LJTJ (整体: ZJ为序列, 总面积为柱状, 已提交面积为折线-红色)
    renderLJTJChart(el, data) {
      const chart = this.initChart(el);
      if (!chart || !data) return;
      const categories = data.map(d => d.ZJ);
      chart.setOption({
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
        legend: { top: 5, left: 'center', data: ['总面积', '已提交面积'] },
        grid: { left: 60, right: 30, top: 45, bottom: 50, containLabel: true },
        xAxis: { type: 'category', data: categories, axisLabel: { rotate: 45, fontSize: 10, interval: 0 } },
        yAxis: { type: 'value', name: '面积(亩)' },
        series: [
          {
            name: '总面积', type: 'bar',
            label: { show: true, position: 'top', formatter: (p) => p.value > 0 ? p.value : '', fontSize: 9 },
            data: data.map(d => Number(d.total?.Area?.toFixed(2) || 0)),
            itemStyle: { color: '#5470c6' }
          },
          {
            name: '已提交面积', type: 'line',
            label: { show: false },
            data: data.map(d => Number(d.YTJ?.Area?.toFixed(2) || 0)),
            itemStyle: { color: '#ee6666' },
            lineStyle: { color: '#ee6666', width: 2 },
            symbol: 'circle', symbolSize: 6
          }
        ]
      });
    },
    // 镇街DRTJ (data: [{KJWZ, Count, Area}, ...], 与整体DRTJ样式一致：水平柱状图, KJWZ为系列)
    renderZJDRTJChart(el, data, zjName) {
      const chart = this.initChart(el);
      if (!chart) return;
      if (!data || data.length === 0) {
        chart.setOption({ title: { text: '(无数据)', left: 'center', top: 'center', textStyle: { fontSize: 14 } } });
        return;
      }
      const categories = [zjName || ''];
      chart.setOption({
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
        legend: { top: 5, left: 'center', data: KJWZ_ORDER },
        grid: { left: 80, right: 30, top: 45, bottom: 30, containLabel: true },
        yAxis: { type: 'category', data: categories, axisLabel: { fontSize: 10 } },
        xAxis: { type: 'value', name: '面积(亩)', nameLocation: 'center', nameGap: 25 },
        series: KJWZ_ORDER.map((k, i) => ({
          name: k, type: 'bar', stack: 'total',
          label: { show: true, position: 'inside', formatter: (p) => p.value > 0 ? p.value : '', fontSize: 9 },
          data: [(() => {
            const item = data.find(d => normalizeKJWZ(d.KJWZ) === k);
            return item ? Number((item.Area || 0).toFixed(2)) : 0;
          })()],
          itemStyle: { color: KJWZ_COLORS[i] }
        }))
      });
    },
    // 镇街LJTJ (KJWZ为序列, total柱状+YTJ折线-红色, 合并耕地补充空间)
    renderZJLJTJChart(el, data) {
      const chart = this.initChart(el);
      if (!chart) return;
      if (!data || data.length === 0) {
        chart.setOption({ title: { text: '(无数据)', left: 'center', top: 'center', textStyle: { fontSize: 14 } } });
        return;
      }
      const merged = {};
      data.forEach(d => {
        const key = normalizeKJWZ(d.KJWZ || '');
        if (!merged[key]) merged[key] = { totalArea: 0, ytjArea: 0 };
        merged[key].totalArea += Number(d.total?.Area || 0);
        merged[key].ytjArea += Number(d.YTJ?.Area || 0);
      });
      const cats = KJWZ_ORDER.filter(k => merged[k]);
      chart.setOption({
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
        legend: { top: 5, left: 'center', data: ['总面积', '已提交面积'] },
        grid: { left: 60, right: 30, top: 45, bottom: 45, containLabel: true },
        xAxis: { type: 'category', data: cats, axisLabel: { fontSize: 10 } },
        yAxis: { type: 'value', name: '面积(亩)' },
        series: [
          {
            name: '总面积', type: 'bar',
            label: { show: true, position: 'top', formatter: (p) => p.value > 0 ? p.value : '', fontSize: 9 },
            data: cats.map(k => Number((merged[k].totalArea || 0).toFixed(2))),
            itemStyle: { color: '#5470c6' }
          },
          {
            name: '已提交面积', type: 'line',
            label: { show: false },
            data: cats.map(k => Number((merged[k].ytjArea || 0).toFixed(2))),
            itemStyle: { color: '#ee6666' },
            lineStyle: { color: '#ee6666', width: 2 },
            symbol: 'circle', symbolSize: 6
          }
        ]
      });
    },
  },
  beforeUnmount() {
    this.charts.forEach(c => c && c.dispose());
  }
};
</script>

<style scoped>
.dialog-header {
  display: flex;
  align-items: center;
  width: 100%;
}
.dialog-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}
.chart-data-wrapper {
  display: flex;
  max-height: 92vh;
  overflow: hidden;
}
.nav-sidebar {
  width: 130px;
  min-width: 130px;
  max-height: 92vh;
  overflow-y: auto;
  background: #f0f2f5;
  border-right: 1px solid #ddd;
  padding: 8px 0;
}
.nav-title {
  font-size: 15px;
  font-weight: 600;
  color: #34495e;
  text-align: center;
  padding: 8px 0;
  border-bottom: 1px solid #ddd;
  margin-bottom: 4px;
}
.nav-item {
  padding: 10px 12px;
  font-size: 15px;
  color: #555;
  cursor: pointer;
  border-left: 3px solid transparent;
  transition: all 0.2s;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.nav-item:hover {
  background: #e8eaed;
  color: #333;
}
.nav-item.active {
  background: #e0f0ff;
  color: #1890ff;
  border-left-color: #1890ff;
  font-weight: 600;
}
.chart-data-container {
  flex: 1;
  max-height: 92vh;
  overflow-y: auto;
  padding: 10px;
}
.page-section {
  background: #fff;
  padding: 10px;
}
.zj-section {
  margin-top: 30px;
  padding-top: 10px;
  border-top: 2px dashed #ccc;
}
.page-title {
  font-size: 22px;
  font-weight: 700;
  color: #1a1a1a;
  text-align: center;
  padding: 10px 0 14px;
  border-bottom: 2px solid #2c3e50;
  margin-bottom: 10px;
}
.cell-title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  text-align: left;
  padding: 4px 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.page-footer {
  font-size: 13px;
  color: #c0392b;
  text-align: left;
  padding: 8px 10px;
  margin-top: 8px;
  border-top: 1px solid #eee;
  line-height: 1.6;
}
.chart-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 430px 430px;
  gap: 10px;
  margin-bottom: 10px;
}
.chart-cell {
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;
  display: flex;
  flex-direction: column;
}
.chart-box {
  width: 100%;
  flex: 1;
  min-height: 0;
}
</style>
